import numeral from "numeral";

const sharedChartOptions = {
  credits: {
    enabled: false,
  },
  exporting: {
    enabled: false
  },
  animation: false,
  title: {
    style: {
      fontWeight: "bold"
    }
  },
  xAxis: {
    lineWidth: 0,
    tickLength: 5,
  },
  yAxis: {
    min: 0,
    title: {
      text: "$ million"
    }
  },
};

const tooltipOptions = {
  animation: true,
  backgroundColor: "transparent",
  borderWidth: 0,
  formatter: function() {
    return `
      <div style="box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.3);">
        <div style="background-color: white; padding: 10px; border-top: 8px solid ${this.color}">
        ${this.series.name}</br>
        <b>${this.key}</b>
        </div>
        <div style="background-color: white; padding: 0px 10px 10px 10px; font-size: 14px;">
          <div style="color: ${this.color}; font-weight: bold">
            ${this.series.tooltipOptions.valuePrefix}${numeral(this.point.y).format("0.0")}${this.series.tooltipOptions.valueSuffix}</b>
          </div>
        </div>
      </div>
    `;
  },
  hideDelay: 100,
  shadow: false,
  shape: "square",
  style: { color: "black", padding: 0 },
  useHTML: true,
  valuePrefix: "$",
  valueSuffix: "m"
};

const legendOptions = {
  padding: 25,
  margin: 15,
  itemMarginBottom: 4,
  itemMarginTop: 1,
  itemStyle: {
    fontWeight: "normal"
  },
  layout: "horizontal",
  symbolHeight: 14,
  symbolWidth: 14,
  symbolRadius: 0,
  reversed: true,
};

const columnPlotOptions = {
  series: {
    stacking: "normal",
    pointStart: 2019,
    borderWidth: 0,
    animation: false,
  }
};

const seriesOptions = [
  {
    name: "Data management/analysis",
    color: "#3fbeee",
  },
  {
    name: "Control systems and SCADA",
    color: "#3184b8",
  },
  {
    name: "Physical parameter sensors",
    color: "#ca4646",
  },
  {
    name: "Laboratory equipment and services",
    color: "#519362"
  },
  {
    name: "Water quality sensors",
    color: "#aed46e",
  },
  {
    name: "Oil & grease sensors",
    color: "#f3b04e",
  },
  {
    name: "Suspended solids sensors",
    color: "#f8cd90",
  },
  {
    name: "Dissolved solids sensors",
    color: "#e6afcf",
  },
  {
    name: "pH/ORP sensors",
    color: "#c1a3c1",
  },
  {
    name: "Total organic carbon sensors",
    color: "#c8539f",
  },
  {
    name: "Residual disinfectant sensors",
    color: "#863b82",
  },
  {
    name: "Dissolved oxygen sensors",
    color: "#b56e50",
  },
  {
    name: "Microbiological sensors",
    color: "#844d49",
  },
  {
    name: "Other parameter sensors",
    color: "#395351",
  },
];

export {
  sharedChartOptions,
  legendOptions,
  tooltipOptions,
  columnPlotOptions,
  seriesOptions
};
